<template>
  <footer style="width: 100%;height: auto;background: #343434;cursor: pointer;">
    <div
        style="width:100%;height: auto;border-bottom: 2px #5C5C5C solid;display: flex;justify-content: center;padding-top:20px;">
      <div v-for="(item,index) in menuData" :key="index"
           style="display: flex;flex-direction: column;margin-right: 44px;">
        <div class="title" style="padding-bottom: 12px;">
          {{ item.title }}
        </div>
        <div v-for="(childItem,childIndex) in item.children" :key="childIndex"
             @click.stop="footItemClick(childItem.path,index+1, childItem.queryKey)"
             class="subTitle">
          {{ childItem.title }}
        </div>
      </div>
      <div style="width: 600px;margin-left: 20px;">
        <div style="width: 100%;height: 140px;margin-bottom: 30px;display: flex;justify-content: space-around;align-items: center;">
          <!-- WeChat -->
          <div style="flex-direction: column;display: flex;align-items: center;width: 100px;">
            <img style="width: 80px;height: 80px;margin-bottom: 8px" src="@/assets/img/footer/icon1.png">
            <div style="font-size: 16px;color: #FFFFFF;margin-top: 8px;">
              {{ footerLabel4 }}
            </div>
            <div
                style="font-size: 12px;color: #FFFFFF;text-align: center;margin-top: 6px;">
              {{ footerLabel5 }}
            </div>
          </div>
          <!-- LinkedIn -->
          <div style="flex-direction: column;display: flex;align-items: center;width: 100px;">
            <img style="width: 80px;height: 80px;margin-bottom: 8px" src="@/assets/img/footer/Linkedin.png">
            <div style="font-size: 16px;color: #FFFFFF;margin-top: 8px;">
              LinkedIn
            </div>
            <div
                style="font-size: 12px;color: #FFFFFF;text-align: center;margin-top: 6px;">
              Follow us
            </div>
          </div>
          <!-- Facebook -->
          <div style="flex-direction: column;display: flex;align-items: center;width: 100px;">
            <img style="width: 80px;height: 80px;margin-bottom: 8px" src="@/assets/img/footer/Facebook.png">
            <div style="font-size: 16px;color: #FFFFFF;margin-top: 8px;">
              Facebook
            </div>
            <div
                style="font-size: 12px;color: #FFFFFF;text-align: center;margin-top: 6px;">
              Follow us
            </div>
          </div>
          <!-- Twitter -->
          <div style="flex-direction: column;display: flex;align-items: center;width: 100px;">
            <img style="width: 80px;height: 80px;margin-bottom: 8px" src="@/assets/img/footer/Twitter.png">
            <div style="font-size: 16px;color: #FFFFFF;margin-top: 8px;">
              Twitter
            </div>
            <div
                style="font-size: 12px;color: #FFFFFF;text-align: center;margin-top: 6px;">
              Follow us
            </div>
          </div>
          <!-- Newsletter -->
          <div @click="subscribeBtn" style="flex-direction: column;display: flex;align-items: center;width: 100px;">
            <img style="width: 80px;height: 80px;margin-bottom: 8px" src="@/assets/img/footer/icon2.png">
            <div style="font-size: 16px;color: #FFFFFF;margin-top: 8px;">
              {{ footerLabel6 }}
            </div>
            <div
                style="font-size: 12px;color: #FFFFFF;text-align: center;margin-top: 6px;">
              {{ footerLabel7 }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="width:100%;height: 80px;display: flex;justify-content: center;align-items: center">
      <div style="width: 1200px;height: 100%;display: flex;align-items: center;justify-content: space-between;">
        <div style="display: flex;align-items: center;">
          <div style="display: flex;align-items: center">
            <img style="width: 48px;height: 48px;border-radius: 48px;margin-right: 12px" src="@/assets/img/footer/icon3.png">
            <div style="font-size: 16px;color: #FFFFFF;width: 240px;">{{
                company1
              }}
            </div>
          </div>
         <div style="display: flex;align-items: center;">
           <img style="width: 48px;height: 48px;border-radius: 48px;margin-right: 12px" src="@/assets/img/footer/icon4.png">
		<div style="font-size: 16px;color: #FFFFFF;width: 220px;">{{
               company2
              }}
            </div>
         </div>
        </div>
        <div style="display:flex;align-items: center;">
          <div style="display: flex;flex-direction: column;align-items: center;">
            <div style="font-size: 20px;color: #FFFFFF;">
              <div>wire China</div>
<!--              <a href="http://test.wirechina.net/d/" style="color: #fff;" target="_blank">wire China</a>-->
            </div>
            <div style="font-size: 18px;color: #FFFFFF;">{{ footerLabel1 }}</div>
          </div>
<!--          <div style="display: flex;flex-direction: column;margin-left: 30px;">-->
<!--            <div style="font-size: 18px;color: #FFFFFF;text-align: right;">-->
<!--              {{ footerLabel2 }}-->
<!--            </div>-->
<!--            <div style="font-size: 18px;color: #FFFFFF;">-->
<!--              <template v-for="(item, index) in footerLabelNation">-->
<!--                <a :href="item.path" :key="item.path" style="color: #fff;" target="_blank">{{ item.nation }}</a>-->
<!--                <span :key="index" v-if="index !== footerLabelNation.length -1"> | </span>-->
<!--              </template>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
    </div>
    <div
        style="width: 100%;height: 20px;display: flex;justify-content: center;align-items: center;font-size: 14px;color: #FFFFFF;opacity: 0.7;background: #000000;">
      {{ footerLabel8 }}
    </div>
    <!--订阅弹窗-->
    <a-modal :title="$t('h.subscribeDialog.title')" :visible="subscribeDialog" :closable="false">
      <a-form-model ref="ruleForm" :label-col="{ span: 4}" :wrapper-col="{ span: 17 }" :model="subscribeForm"
                    :rules="formRules">
        <a-form-model-item :label="$t('h.subscribeDialog.label1')" :colon="false" prop="roleName">
          <a-select v-model="subscribeForm.roleName" :placeholder="$t('h.subscribeDialog.holder1')">
            <a-select-option
                v-for="(item,index) in [{cn:'展商',en:'Exhibitor'},{cn:'观众',en:'Visitor'},{cn:'媒体',en:'Medium'}]"
                :key="index">
              {{ $language === 'ZH' ? item.cn : item.en }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="$t('h.subscribeDialog.label2')" :colon="false" prop="companyName">
          <a-input v-model="subscribeForm.companyName" :placeholder="$t('h.subscribeDialog.holder2')"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('h.subscribeDialog.label3')" :colon="false" prop="contactName">
          <a-input v-model="subscribeForm.contactName" :placeholder="$t('h.subscribeDialog.holder3')"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('h.subscribeDialog.label4')" :colon="false" prop="email">
          <a-input v-model="subscribeForm.email" :placeholder="$t('h.subscribeDialog.holder4')"/>
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button @click="subscribeConfirm" type="danger" style="background-color: #F0831E;">
          {{ $t('h.subscribeDialog.btn1') }}
        </a-button>
        <a-button @click="subscribeCancel">
          {{ $t('h.subscribeDialog.btn2') }}
        </a-button>
      </template>
    </a-modal>
  </footer>
</template>
<script>
import {EventBus} from "../assets/event-bus";
import {addExhibition} from "@/assets/api";

export default {
  name: 'app-footer',
  data() {
    return {
      subscribeDialog: false,
      subscribeForm: {
        roleName: undefined,
        companyName: null,
        contactName: null,
        email: null
      },
      formRules: {
        roleName: [{required: true, message: this.$t('h.subscribeDialog.holder1'), trigger: 'change'}],
        companyName: [{required: true, message: this.$t('h.subscribeDialog.holder2'), trigger: 'blur'}],
        contactName: [{required: true, message: this.$t('h.subscribeDialog.holder3'), trigger: 'blur'}],
        email: [{required: true, message: this.$t('h.subscribeDialog.holder4'), trigger: 'blur'}, {
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error(this.$t('h.vistorRegister.title2Box.holder11')));
            }
            const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!emailReg.test(value)) {
              callback(new Error(this.$t('h.vistorRegister.title2Box.holder17')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
      },
      company1: this.$t('h.footerCompanyName1'),
      company2: this.$t('h.footerCompanyName2'),
      footerLabel1: this.$t('h.footerLabel1'),
      footerLabel2: this.$t('h.footerLabel2'),
      // footerLabel3:this.$t('h.footerLabel3'),
      footerLabel4: this.$t('h.footerLabel4'),
      footerLabel5: this.$t('h.footerLabel5'),
      footerLabel6: this.$t('h.footerLabel6'),
      footerLabel7: this.$t('h.footerLabel7'),
      footerLabel8: this.$t('h.footerLabel8'),
      footerLabelNation: [
        {
          nation: this.$t('h.footerLabel3Germany'),
          path: "https://www.wire-tradefair.com/"
        },
        {
          nation: this.$t('h.footerLabel3Eurasia'),
          path: "https://www.wire-india.com/"
        },
        {
          nation: this.$t('h.footerLabel3Mexico'),
          path: "http://www.wire-southeastasia.com/"
        },
        {
          nation: this.$t('h.footerLabel3Thailand'),
          path: "https://www.wire-mea.com/"
        },
        {
          nation: this.$t('h.footerLabel3India'),
          path: "https://www.wire-eurasia.com/"
        },
        {
          nation: this.$t('h.footerLabel3MEA'),
          path: "https://www.wire-tube-mexico.com/"
        },
      ],
      menuData: [
        {
          title: this.$t('h.tabName2'),
          children: [
            {
              title: this.$t('h.tabName2Item1'),
              path: '/about',
            },
            {
              title: this.$t('h.tabName2Item3'),
              path: '/dynamic',
            },
            {
              title: this.$t('h.tabName2Item5'),
              path: '/transport',
            }
          ]
        },
        {
          title: this.$t('h.tabName3'),
          children: [
            {
              title: this.$t('h.tabName3Item1'),
              path: '/czProcess'
            },
            {
              title: this.$t('h.tabResourceCenter'),
              path: '/resource-center'
            },
            // {
            //   title: this.$t('h.tabName3Item2'),
            //   path: '/czsList'
            // },
            {
              title: this.$t('h.tabName3Item3'),
              path: '/zwApply'
            },
            {
              title: this.$t('h.tabName3Item4'),
              path: '/zsPropagateApply'
            },
            {
              title: localStorage.getItem('userIdentity') === 'zs' ? this.$t('h.tabName3Item7') : this.$t('h.tabName3Item5'),
              path: localStorage.getItem('userIdentity') === 'zs' ? '/zsCenter' : '/zsLogin'
            },
            //{
            //  title: this.$t('h.tabName3Item6'),
            //  path: '/visa-apply'
            //}
          ]
        },
        {
          title: this.$t('h.tabName4'),
          children: [
            {
              title: this.$t('h.tabName4Item1'),
              path: '/vistor/register'
            },
            {
              title: this.$t('h.tabResourceCenter'),
              path: '/resource-center'
            },
            // {
            //   title: this.$t('h.tabName4Item2'),
            //   path: '/vistor/materials'
            // },
            {
              title: this.$t('h.tabName4Item3'),
              path: '/product/home'
            },
            // {
            //   title: localStorage.getItem('userIdentity') === 'visitor' ? this.$t('h.tabName4Item6') : this.$t('h.tabName4Item4'),
            //   path: localStorage.getItem('userIdentity') === 'visitor' ? '/vistor/center' : '/vistor/login'
            // },
            //{
            //  title: this.$t('h.tabName4Item5'),
            //  path: '/visa-apply'
            //}
          ]
        },
        {
          title: this.$t('h.tabName5'),
          children: [
            {
              title: this.$t('h.tabName5Item1'),
              path: '/meet/industry-conference'
            },
            {
              title: this.$t('h.tabName5Item2'),
              path: '/meet/technical-exchange'
            },
            {
              title: this.$t('h.tabName5Item3'),
              path: '/meet/cable-cloud'
            },
            {
              title: this.$t('h.tabName5Item4'),
              path: '/meet/overseas-exhibition'
            },
            // {
            //   title: this.$t('h.tabName5Item5'),
            //   path: '/meet/other'
            // }
          ]
        },
        {
          title: this.$t('h.tabName6'),
          children: [
            {
              title: this.$t('h.tabName6Item1'),
              path: '/product/supplier',
              queryKey: '供应商'
            },
            {
              title: this.$t('h.tabName6Item2'),
              path: '/product/supplier',
              queryKey: '产品'
            },
            {
              title: this.$t('h.tabName6Item3'),
              path: '/product/asktobuy'
            },
            {
              title: this.$t('h.tabName6Item4'),
              path: '/product/release'
            }
          ]
        }
      ]
    }
  },
  methods: {
    subscribeConfirm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$axios.post(addExhibition, this.subscribeForm).then(res => {
            if (res && res.data.success) {
              this.$message.success(res.data.message)
              this.subscribeCancel()
            } else {
              this.$message.error(res.data.message)
            }
          })
        }
      });
    },
    subscribeCancel(){
      this.$refs.ruleForm.resetFields();
      this.subscribeDialog = false;
    },
    isPhoneNumber(str) {
      const reg = /^1[3-9]\d{9}$/;
      return reg.test(str);
    },
    footItemClick(path, index, queryKey) {
      if (!path) {
        this.$message.error('暂未开放')
        return false;
      }
      if(path === '/product/release'){
		          // if(localStorage.getItem('token')){
		          //   if(localStorage.getItem('userIdentity') === 'zs'){
		          //     this.$router.push('/zsCenter')
		          //     localStorage.setItem('change-a-menu','发布采购需求')
		          //   } else {
		          //     this.$router.push('/vistor/center')
		          //     localStorage.setItem('change-a-menu','发布采购需求')
		          //   }
		          // } else {
		          //   this.$message.warning(this.$t('h.custom.PleaseLogin'))
		          // }
        window.open('https://qywx.wjx.cn/vm/rpYvq2P.aspx', '_blank')
        return false;
      }
      if (queryKey) {
        localStorage.setItem('queryKey', queryKey)
      }
      if (path === '/zsLogin') {
        if (localStorage.getItem('userIdentity') === 'visitor') {
          this.$message.error('请先退出观众登录')
          return false
        }
      } else if (path === '/vistor/login') {
        if (localStorage.getItem('userIdentity') === 'zs') {
          this.$message.error('请先退出展商登录')
          return false
        }
      }
      // EventBus.$emit('submenu-selected', index);
      this.$router.push(path)
    },
    subscribeBtn() {
      this.subscribeDialog = true
    }
  }
};
</script>
<style lang="scss" scoped>
.title {
  font-size: 16px;
  color: white;
  font-weight: bold;
  line-height: 24px;
}

.subTitle {

  font-size: 14px;
  color: white;
  margin-top: 6px;
  cursor: pointer;
  font-weight: 500;
}

.subTitle:hover {
  color: #3DA5FF;
}
</style>
